

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class Search extends Vue {
    @Prop() readonly placeholder!: string
    @Prop() readonly value!: string
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    @Prop({ type: Boolean, default: false }) readonly rounded!: boolean
    internalValue: string = null
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    transformInput(value: string) {
        if (typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    transformOutput(value: string) {
        if (typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    onPressEnter(): void {
        this.$emit('keyup-enter', this.internalValue)
    }

    get componentClass(): object {
        return {
            'search': true,
            'search--focus': this.focus,
            'search--white': this.white,
            'search--rounded': this.rounded,
        }
    }
}
